module.exports = __webpack_public_path__ + "img/purple_logo_bg.716cc371.png";